import { z } from 'zod';

import { selectSecretInputSchema } from '@/console/features/vaults/components/form-select-secret/form-select-secret.validation';
import { ProjectTypeEnum } from '@/shared/types/types.generated';
import { optionalString, requiredString } from '@/shared/utils/validation';

export const createProjectInputSchema = (isGroupRequired = false) =>
  selectSecretInputSchema.extend({
    name: requiredString(),
    description: optionalString(),
    vendorId: requiredString(),
    groupId: isGroupRequired ? requiredString() : optionalString(),
    projectType: z.nativeEnum(ProjectTypeEnum),
    ideConfigId: requiredString(),
    attachedLicenses: z.array(requiredString()).optional(),
    fileName: requiredString(),
    file: z.instanceof(File),
    tags: z.array(requiredString()).optional(),
    metaData: z.record(z.unknown()).optional(),
  });
